import { dateTimeFormat } from '@/utility/utility_functions'

class CustomerLog {
  constructor (timestamp, content) {
    this.timestamp = timestamp
    this.content = content
  }

  static asCustomerLogs (json) {
    return json.map(jsonCustomerLog => {
      return CustomerLog.asCustomerLog(jsonCustomerLog)
    })
  }

  static asCustomerLog (json) {
    return new CustomerLog(
      json.timestamp ? dateTimeFormat(json.timestamp, 'YYYY-MM-DD HH:mm') : '',
      json.content
    )
  }
}

export {
  CustomerLog
}
